<template>
  <v-container>
    <v-container>
      <v-card flat>
        <v-row class="nopadding">
          <v-col :cols="calendarType=='month'?12:8" class="noBotPadding">
            <RyouSelect :class="{ryouSelectPCStyle1:calendarType=='month',ryouSelectMobileStyle1:calendarType=='week'}"
              :label="'物件グループ選択'" :items="buildGroupOptionItems" :itemText="'build_group_name'"
              :itemValue="'build_group_id'" v-model="buildGroupSelectValue" :value="buildGroupSelectValue">
            </RyouSelect>
          </v-col>
          <v-col cols="4" class="noBotPadding" v-if="calendarType=='week'">
            <RyouSelect class="ryouSelectMobileStyle3" :items="typeItem" :itemText="'typeText'" :itemValue="'typeValue'"
              v-model="typeSelectOptionValue" :value="typeSelectOptionValue" disabled>
            </RyouSelect>
          </v-col>
        </v-row>
        <v-row class="nopadding" v-if="calendarType=='month'">
          <v-col cols="5" class="noBotPadding noRigPadding">
            <v-row>
              <v-card-title style="height: 40px;" v-if="!buildGroupSelectCtrl">
                予約者
              </v-card-title>
              <v-col class="noBotPadding">
                <!--<RyouSelect class="ryouSelectPCStyle2" :items="reserveUserOptionItems" :itemText="item => item.user_id + ' ' + item.user_name" 
                  :itemValue="'user_id'" v-model="reserveUserSelectValue" :value="reserveUserSelectValue"
                  :disabled="reserveUserSelectCtrl" v-if="!buildGroupSelectCtrl">
                </RyouSelect>-->
                  <RyouAutocomplete class="ryouSelectPCStyle2" :items="reserveUserOptionItems"  :itemValue="'user_id'" :itemText="item => item.user_id + ' ' + item.user_name"
                                    v-model="reserveUserSelectValue" :value="reserveUserSelectValue"
                                    :disabled="reserveUserSelectCtrl" v-if="!buildGroupSelectCtrl">

                  </RyouAutocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="5" class="noTopBotPadding">
            <v-toolbar flat class="noTopBotPadding">
              <v-btn fab text small color="grey darken-2" @click="calendarPrv" :disabled="arrowCtrlFlag">
                <v-icon x-large> mdi-chevron-left </v-icon>
              </v-btn>
              <v-toolbar-title>
                <h2>{{this.canderTitle}}</h2>
              </v-toolbar-title>
              <v-btn fab text small color="grey darken-2" @click="calendarNext" :disabled="arrowCtrlFlag">
                <v-icon x-large> mdi-chevron-right </v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>
          <v-col cols="2" class="noBotPadding">
            <RyouSelect class="ryouSelectPCStyle3" :items="typeItem" :itemText="'typeText'" :itemValue="'typeValue'"
              v-model="typeSelectOptionValue" :value="typeSelectOptionValue" disabled>
            </RyouSelect>
          </v-col>
        </v-row>
        <v-row class="nopadding" v-if="calendarType=='week'">
          <v-spacer></v-spacer>
          <v-col class="noTopBotPaddingMobile">
            <v-toolbar flat class="noTopBotPaddingMobile">
              <v-btn fab text small color="grey darken-2" @click="calendarPrv" :disabled="arrowCtrlFlag">
                <v-icon x-large> mdi-chevron-left </v-icon>
              </v-btn>
              <v-toolbar-title>
                <h5>{{this.canderTitle}}</h5>
              </v-toolbar-title>
              <v-btn fab text small color="grey darken-2" @click="calendarNext" :disabled="arrowCtrlFlag">
                <v-icon x-large> mdi-chevron-right </v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
    </v-container>
    <v-container>
      <v-sheet height="700">
        <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" :type="calendarType"
          @click:event="showEvent" @click:date="btnClick($event)">
          <template v-slot:day="props">
            <template v-for="(ent, index) in notOfferEventsDateList">
              <div :key="index" class="disable" v-if="ent == props.date" style="text-align: center">
                提供無し
              </div>
            </template>
          </template>
          <template v-slot:event="{ event }">
            <v-row :dense="calendarType=='week'">
              <v-col :cols="calendarType=='month'?10:5" style="text-align:center"
                v-if="notOfferEventsDateList.indexOf(event.start) == -1">
                {{ event.name }}
              </v-col>
              <v-col :cols="calendarType=='month'?2:7" style="background-color: #FFFFFF !important;text-align:center"
                v-if="notOfferEventsDateList.indexOf(event.start) == -1">
                <v-icon small color="grey" v-if="event.before && event.checked">
                  mdi-check-circle
                </v-icon>
                <v-icon small color="blue" v-if="!event.before && event.checked">
                  mdi-check-circle
                </v-icon>
                <v-icon small v-if="!event.checked">
                  mdi-checkbox-blank-circle-outline
                </v-icon>
              </v-col>
              <v-col cols="12" style="text-align:center"
                v-if="calendarType=='week' && notOfferEventsDateList.indexOf(event.start) != -1">
                {{ event.name }}
              </v-col>
            </v-row>
          </template>
        </v-calendar>
      </v-sheet>
      <v-card-actions>
        <RyouBlackBtn :label="'一括登録/解除'" :disabled="collectiveBtnCtrl" :handlerClick="collectiveReservation">
        </RyouBlackBtn>
      </v-card-actions>
    </v-container>
    <MealReservationDayDialog ref="modalDayReservation" @reCalendar="calendarGet"></MealReservationDayDialog>
    <MealReservationCollectiveDialog ref="modalCollectiveReservation" @reCalendar="calendarGet">
    </MealReservationCollectiveDialog>
  </v-container>
</template>

<script>
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouSelect from "../../components/formInput/RyouSelect";
  import RyouAutocomplete from "../../components/formInput/RyouAutocomplete";
  import MealReservationDayDialog from "./modules/MealReservationDayDialog.vue";
  import MealReservationCollectiveDialog from "./modules/MealReservationCollectiveDialog.vue";
  export default {
    name: "MealReservation",
    components: {
      RyouBlackBtn,
      RyouSelect,
      MealReservationDayDialog,
      MealReservationCollectiveDialog,
      RyouAutocomplete
    },
    data() {
      return {
        p2Form: true,
        focus: "",
        calendarType: null,
        typeSelectOptionValue: null,
        typeItem: [],
        buildGroupSelectCtrl: null,
        reserveUserSelectCtrl: null,
        collectiveBtnCtrl: null,
        canderTitle: "",//カレンダーのヘッダ
        mealDeadLineDay: "",//締め切りの日
        hasEventsDateList: [],//メニューが存在する日付["YYYY-MM-dd","YYYY-MM-dd",...]
        hasEventsDateDetailedDataList: [],//メニューが存在する詳細データ
        mealClasses: [],
        mealNameClassReserve: [],//日付の食事区分、食事名["1"＆食事一＆true,"2"＆食事二&false,...]
        events: [],//メニューが存在毎日のイベント[ある日の食事一,食事二,...]
        notOfferEventsDateList: [],//提供無し日付["YYYY-MM-dd","YYYY-MM-dd",...]
        notOfferEventsDateDetailedDataList: [],//提供無し日付詳細データ
        buildGroupSelectValue: "",
        buildGroupOptionItems: [],
        reserveUserSelectValue: "",
        reserveUserOptionItems: [],
        colors: [
          "#FF9800",//オレンジ
          "#673AB7",//深紫
          "#4CAF50",//緑
          "#E91E63",//ピンク
          "#3F51B5",//インディゴ
          "#009688",//teal
          "#FF5722",//深オレンジ
          "#8BC34A",//light-green
          "#D32F2F",//red darken-2
          "#1565C0"//blue darken-3
        ],
        arrowCtrlFlag: false
      };
    },
    created() {
      this.machineModelCheck();
      this.initData();
      this.reserveUserSelectCtrl = true;
      if (this.$store.getters.getUserClass == "3") {
        this.buildGroupSelectCtrl = true;
        this.collectiveBtnCtrl = false;
      }
      else {
        this.collectiveBtnCtrl = true;
      }
    },
    mounted() {
      this.canderTitle = this.initCanderValue(this.$refs.calendar.title);

      if (this.calendarType == "week") {
        this.$("div.v-calendar-daily__body").remove();
        this.$("div.v-calendar-daily__intervals-head").remove();
        this.$(".v-sheet.theme--light").height("auto");
        this.smallCalendarWeekListStyle();
      }
    },
    watch: {
      buildGroupSelectValue(value) {
        this.reserveUserSelectValue = "";
        this.calendarDataClear();
        this.mealClassDeadLineGet();

        if (this.$store.getters.getUserClass == "3") {
          this.calendarGet();
        } else {
          let params = {
            buildGroupId: value
          }
          //selectBoxで値を取る
          this.getRequest("/mealReservation/reserveUserGet", params, this.$store.getters.getUserToken).then(data => {

            if (data.success && data.status == "200") {
              this.reserveUserSelectCtrl = false;
                this.reserveUserOptionItems = data.result;
            }
          });
        }
           
      },
      reserveUserSelectValue(value) {
        if (value != "") {
          this.collectiveBtnCtrl = false;
          this.calendarGet();
        } else {
          if (this.$store.getters.getUserClass == "3") {
            this.collectiveBtnCtrl = false;
          } else {
            this.collectiveBtnCtrl = true;
          }
        }
      }
    },
    methods: {
      smallCalendarWeekListStyle() {
        this.$(".v-btn--fab.v-size--default").addClass("smallCalendarWeekListStyle");
      },
      //日付をクリック
      btnClick(date) {
        if (this.calendarType == "month") {
          let getNowMonth = this.$refs.calendar.title.split("月 ");

          // 当月かどうかを判断
          if (date.month == getNowMonth[0]) {
            this.btnClickOpen(date);
          } else {
            setTimeout(() => {
              this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
              this.calendarGet();
            }, 100);
          }
        } else {
          this.btnClickOpen(date);
        }
      },
      btnClickOpen(date) {
        if (!(date.date < this.mealDeadLineDay)) {
          let DialogData = this.calendarDialogDataGet(date.date);
          if (DialogData) {
            // パラメータ1:ダイアログデータ、パラメータ2:物件グループID、パラメータ3:ユーザID
            if (this.$store.getters.getUserClass == "3") {
              this.$refs.modalDayReservation.getInputValue(DialogData,
                this.buildGroupSelectValue, this.$store.getters.getUserId);
            } else {
              this.$refs.modalDayReservation.getInputValue(DialogData,
                this.buildGroupSelectValue, this.reserveUserSelectValue);
            }
          }
        }
      },
      //イベントクリック
      showEvent(event) {
        if (!(event.day.date < this.mealDeadLineDay)) {
          let DialogData = this.calendarDialogDataGet(event.day.date);
          if (DialogData) {
            // パラメータ1:ダイアログデータ、パラメータ2:物件グループID、パラメータ3:ユーザID
            if (this.$store.getters.getUserClass == "3") {
              this.$refs.modalDayReservation.getInputValue(DialogData,
                this.buildGroupSelectValue, this.$store.getters.getUserId);
            } else {
              this.$refs.modalDayReservation.getInputValue(DialogData,
                this.buildGroupSelectValue, this.reserveUserSelectValue);
            }
          }
        }
      },
      mealNameClassReserveGet() {

        let that = this;
        this.mealClasses.forEach((item) => {

          let mealNameClassReserveItem = {
            meal_class: item.meal_class,
            meal_name: item.meal_name,
            reserve_flg: false
          }

          that.mealNameClassReserve.push(mealNameClassReserveItem);
        });
        return that.mealNameClassReserve;
      },
      collectiveReservation() {
        if (this.$store.getters.getUserClass == "3") {
          this.$refs.modalCollectiveReservation.getInputValue(this.mealNameClassReserveGet(),
            this.buildGroupSelectValue, this.$store.getters.getUserId, this.mealDeadLineDay);
        } else {
          this.$refs.modalCollectiveReservation.getInputValue(this.mealNameClassReserveGet(),
            this.buildGroupSelectValue, this.reserveUserSelectValue, this.mealDeadLineDay);
        }
      },
      machineModelCheck() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

        if (flag === null || flag === undefined || flag === "") {
          console.log("pc端");

          this.typeItem = [{ typeValue: "1", typeText: "月" }];
          this.typeSelectOptionValue = "1";
          this.calendarType = "month";
        } else {
          console.log("移动端");

          this.typeItem = [{ typeValue: "2", typeText: "週" }];
          this.typeSelectOptionValue = "2";
          this.calendarType = "week";
        }

      },
      initData() {
        let params = {
          userId: this.$store.getters.getUserId,
          userClass: this.$store.getters.getUserClass,
        }
        //selectBoxで値を取る
        this.getRequest("/mealReservation/buildGroupGet", params, this.$store.getters.getUserToken).then(data => {

          if (data.success && data.status == "200") {
            this.buildGroupOptionItems = data.result;

            if (this.$store.getters.getUserClass == "3") {
              this.buildGroupSelectValue = this.buildGroupOptionItems[0].build_group_id;
            }
          }
        });
      },
      calendarDataClear() {
        // データクリア
        this.mealNameClassReserve = [];
        this.events = [];
        this.hasEventsDateList = [];
        this.hasEventsDateDetailedDataList = [];
        this.notOfferEventsDateList = [];
        this.notOfferEventsDateDetailedDataList = [];
        this.$(".v-calendar-weekly__day:has(div.disable)").removeClass("mask");
        this.$("div.disable").remove();
      },
      // 食事締め切り日取得
      mealClassDeadLineGet() {
        let that = this;
        let mealClassDeadLineParams = {
          buildGroupId: this.buildGroupSelectValue
        };

        this.getRequest("/mealReservation/mealClassGet", mealClassDeadLineParams, this.$store.getters.getUserToken).then(data => {
          // 食事区分取得
          if (data.success) {
            that.mealClasses = data.result;
          }
        });

        this.getRequest("/mealReservation/mealDeadLineGet", mealClassDeadLineParams, this.$store.getters.getUserToken).then(data => {
          // 食事締め切り日取得
          if (data.success) {
            that.mealDeadLineDay = data.result;
          }
        });
      },
      //カレンダーデータ取得
      calendarGet() {

        this.calendarDataClear();

        if ((this.reserveUserSelectValue != null && this.reserveUserSelectValue != "") || this.$store.getters.getUserClass == "3") {

          let that = this;
          let calendarParams = null;

          let queryUserId = null;

          if (this.$store.getters.getUserClass == "3") {
            queryUserId = this.$store.getters.getUserId;
          } else {
            queryUserId = this.reserveUserSelectValue;
          }

          if (this.$refs.calendar.title.split("月").length == 3) {

            let title = this.$refs.calendar.title;
            //"11月-12月2021"
            //"12月2021-1月2022"
            title = title.replace(/ /g, "");

            //["11", "-12", "2021"]
            //["12", "2021-1", "2022"]
            let firstSplitResult = title.split("月");
            let firstMonth = firstSplitResult[0];

            //["", "12"]
            //["2021", "1"]
            let secondSplitResult = firstSplitResult[1].split("-");

            if (secondSplitResult[0] != "") {
              calendarParams = {
                buildGroupId: this.buildGroupSelectValue,
                currentYM1: secondSplitResult[0] + "-" + firstMonth,
                currentYM2: firstSplitResult[2] + "-" + secondSplitResult[1],
                userId: queryUserId
              };
            } else {
              calendarParams = {
                buildGroupId: this.buildGroupSelectValue,
                currentYM1: firstSplitResult[2] + "-" + firstMonth,
                currentYM2: firstSplitResult[2] + "-" + secondSplitResult[1],
                userId: queryUserId
              };
            }
          } else {
            //年月取得
            let titleYear = this.canderTitle.split("年")
            let titleMonth = titleYear[1].split("月")
            calendarParams = {
              buildGroupId: this.buildGroupSelectValue,
              currentYM1: titleYear[0] + "-" + titleMonth[0],
              currentYM2: null,
              userId: queryUserId
            };
          }

          this.arrowCtrlFlag = true;

          this.getRequest("/mealReservation/calendarReserveGet", calendarParams, this.$store.getters.getUserToken).then(data => {
            if (data.success) {
              // 現在の月を循環
              for (let dateIndex = 0; dateIndex < data.result.length; dateIndex++) {

                //取得当日
                let dateItem = data.result[dateIndex];
                // 取得当日(Key,Value)
                for (let dateKey in dateItem) {

                  //取得当日データ
                  let dateData = dateItem[dateKey];
                  // 取得当日データあり
                  if (dateData.length != 0) {
                    // データが存在する日付
                    if (dateData[0].offer_flg == "1") {
                      //食事提供あり結果セット
                      if (that.hasEventsDateList.indexOf(dateKey) < 0) {
                        that.hasEventsDateList.push(dateKey);
                        that.hasEventsDateDetailedDataList.push(dateItem);
                      }
                    } else if (dateData[0].offer_flg == "0") {
                      //食事提供なし結果セット
                      if (that.notOfferEventsDateList.indexOf(dateKey) < 0) {
                        that.notOfferEventsDateList.push(dateKey);
                        that.notOfferEventsDateDetailedDataList.push(dateItem);
                      }
                    }
                  }
                }
              }

              this.getValue();
            }
            this.arrowCtrlFlag = false;
          });
        }
      },
      //カレンダー、ポップアップ、データ取得
      calendarDialogDataGet(value) {
        for (let hedddIndex = 0; hedddIndex < this.hasEventsDateDetailedDataList.length; hedddIndex++) {

          let hedddItem = this.hasEventsDateDetailedDataList[hedddIndex];

          for (let hedddKey in hedddItem) {
            if (hedddKey == value) {
              return hedddItem;
            }
          }
        }

      },
      //カレンダーヘッドの初期化時間
      initCanderValue(title) {

        //"12月2021"
        //"11月-12月2021"
        //"12月2021-1月2022"
        title = title.replace(/ /g, "");

        let newTitile = null;
        if (title.split("月").length == 3) {
          //["11", "-12", "2021"]
          //["12", "2021-1", "2022"]
          let firstSplitResult = title.split("月");
          let firstMonth = firstSplitResult[0];

          //["", "12"]
          //["2021", "1"]
          let secondSplitResult = firstSplitResult[1].split("-");

          if (secondSplitResult[0] != "") {
            newTitile = secondSplitResult[0] + "年" + firstMonth + "月" + "～" + secondSplitResult[1] + "月";
          } else {
            newTitile = firstSplitResult[2] + "年" + firstMonth + "月" + "～" + secondSplitResult[1] + "月";
          }
        } else {
          let titleList = title.split("月");
          newTitile = titleList[1] + "年" + titleList[0] + "月";
        }
        return newTitile;
      },
      //カレンダーの来月
      calendarNext() {
        this.$refs.calendar.next();

        setTimeout(() => {
          if (this.calendarType == "week") {
            this.smallCalendarWeekListStyle();
          }
          this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
          this.calendarGet();
        }, 10);
      },
      //カレンダーの前の月
      calendarPrv() {
        this.$refs.calendar.prev();

        setTimeout(() => {
          if (this.calendarType == "week") {
            this.smallCalendarWeekListStyle();
          }
          this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
          this.calendarGet();
        }, 10);
      },
      //カレンダーデータのロードが完了しました。
      getValue() {
        // データが存在する、メニュー表示
        for (let hedddIndex = 0; hedddIndex < this.hasEventsDateDetailedDataList.length; hedddIndex++) {

          let hasEventsDateDetailedDataItem = this.hasEventsDateDetailedDataList[hedddIndex];

          for (let hedddKey in hasEventsDateDetailedDataItem) {

            let hasEventsDateDetailedDataItemMenu = hasEventsDateDetailedDataItem[hedddKey];

            for (let hedddimIndex = 0; hedddimIndex < hasEventsDateDetailedDataItemMenu.length; hedddimIndex++) {

              if (hedddKey < this.mealDeadLineDay) {
                this.events.push({
                  name: hasEventsDateDetailedDataItemMenu[hedddimIndex].menu,
                  start: hedddKey,
                  color: "#795548",
                  timed: false,
                  before: true,
                  checked: Number(hasEventsDateDetailedDataItemMenu[hedddimIndex].reserve_flg)
                });
              }
              else {
                this.events.push({
                  name: hasEventsDateDetailedDataItemMenu[hedddimIndex].menu,
                  start: hedddKey,
                  color: this.colors[hedddimIndex],
                  timed: false,
                  before: false,
                  checked: Number(hasEventsDateDetailedDataItemMenu[hedddimIndex].reserve_flg)
                });
              }
            }
          }
        }
        if (this.calendarType == "week") {
          for (let index = 0; index < this.notOfferEventsDateList.length; index++) {
            this.events.push({
              name: "提供無し",
              start: this.notOfferEventsDateList[index],
              color: "#bebebe",
              timed: false,
            });
          }
        }
        setTimeout(() => {
          // disableを含む要素を見つけて、スタイルを追加します
          this.$(".v-calendar-weekly__day:has(div.disable)").addClass("mask");
        }, 100);
      },
    },
  };
</script>

<style lang="scss">
  .ryouSelectPCStyle1 {
    width: 14.5%;
    height: 40px;
  }

  .ryouSelectMobileStyle1 {
    width: 100%;
    height: 40px;
  }

  .ryouSelectPCStyle2 {
    width: 40%;
    height: 40px;
  }

  .ryouSelectPCStyle3 {
    width: 55%;
    height: 40px;
    float: right;
  }

  .ryouSelectMobileStyle3 {
    width: 100%;
    height: 40px;
    float: right;
  }

  .nopadding {
    padding: 0px;
  }

  .noBotPadding {
    padding-bottom: 0px;
  }

  .noTopBotPadding {
    padding: 0px 14px;
  }

  .noTopBotPaddingMobile {
    padding: 0px 5px;
  }

  .noRigPadding {
    padding-right: 0px;
  }

  .mask {
    box-sizing: border-box;
    border: 1px solid #9E9E9E !important;
    background-color: #bebebe !important;
  }

  .smallCalendarWeekListStyle {
    width: 25px !important;
    height: 25px !important;
  }
</style>